// @flow
/* eslint-disable max-len */
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import _ from 'lodash';

import { share } from 'client/utils/share';
import { Responsive } from 'client/components/common/Responsive';
import { analytics } from 'common/utils/ga';
import { SHARE_CONSTANTS } from 'client/constants';

import * as css from './Socials.scss';

type Props = {
	className?: string,
	isBackBtnVisible?: boolean,
	isHeaderSociallsVisible?: boolean,
	onBackClick?: Function,
	headerBackground?: string,
	iconsColor: string,
	inContentLocated?: boolean,
	inHeaderLocated?: boolean,
	generalShareTitle?: string,
	title?: ?{
		titleColor?: string,
		text?: string,
	},
	// eslint-disable-next-line react/no-unused-prop-types
	shareResult: {
		total: number,
		description: string,
		selected: number,
	},
	shareResults?: boolean,

	history: RouterHistory,
	location: RouterLocation,

	inItemLocated?: boolean,
	shareItemId?: string,
	itemShareDescription?: string,
	itemShareTitle?: string,
	checklistInfo: ChecklistsItem,
};

type State = {
	isOpen: boolean,
};

class Socials extends React.Component<Props, State> {
	containerRef: { current: null | HTMLDivElement } = React.createRef();

	static defaultProps = {
		className: '',
		inContentLocated: false,
		inHeaderLocated: false,
		generalShareTitle: '',
		headerBackground: 'transparent',
		isBackBtnVisible: false,
		isHeaderSociallsVisible: false,
		shareResults: false,
		onBackClick: _.noop,
		title: null,
		inItemLocated: false,
		shareItemId: '',
		itemShareDescription: '',
		itemShareTitle: '',
	};

	state = {
		isOpen: false,
	};

	toggleOpenMenu = (e: SyntheticEvent<HTMLDivElement>) => {
		this.setState(prevState => ({
			isOpen: !prevState.isOpen,
		}));
	};

	onShareClick = (type: any) => {
		const isDesktop = Responsive.isMatching(Responsive.DESKTOP);

		if (!isDesktop) {
			analytics.gtag.event('Share activity', { CUSTOM_PARAMETER: type });
		}
	};

	onShareResultClick = (type: any) => {
		analytics.gtag.event('Share result', { CUSTOM_PARAMETER: type });
	};

	onShare = (e: SyntheticEvent<HTMLButtonElement>) => {
		const type = e.currentTarget.id;
		const {
			inItemLocated,
			shareItemId,
			itemShareDescription,
			itemShareTitle,
			inContentLocated,
			inHeaderLocated,
			generalShareTitle,
		} = this.props;
		if (this.props.inContentLocated) {
			const options = {
				shareType: 'custom',
				description: _.get(this.props, 'shareResult.description', ''),
				inContentLocated,
				generalShareTitle,
			};

			this.props.history.push(
				`${this.props.location.pathname}?shareType=custom&total=${_.get(
					this.props,
					'shareResult.total',
					'0'
				)}&selected=${_.get(this.props, 'shareResult.selected', '0')}&itemId=${_.get(
					this.props,
					'shareResult.itemId',
					''
				)}`
			);

			share(type, options, () => {
				this.onShareResultClick(type);
			});
		} else if (inItemLocated) {
			// If share makes from item (in horizontal checklist)
			share(type, { shareItemId, itemShareDescription, itemShareTitle }, () => {
				this.onShareClick(type);
			});
		} else {
			this.props.history.push(`${this.props.location.pathname}`);
			share(type, { inHeaderLocated, generalShareTitle }, () => {
				this.onShareClick(type);
			});
		}
	};

	onBack = () => {
		const { onBackClick } = this.props;

		analytics.gtag.event('Click Back');
		if (onBackClick) {
			onBackClick();
		}
	};

	render() {
		const {
			className,
			headerBackground,
			iconsColor,
			title,
			isBackBtnVisible,
			inContentLocated,
			isHeaderSociallsVisible,
			shareResults,
			inItemLocated,
			checklistInfo,
		} = this.props;
		const isDesktop = Responsive.isMatching(Responsive.DESKTOP);
		const backBtnLabel = 'חזרה';
		// console.info('checklistInfo', checklistInfo);
		const isOneVotingPerUser = _.get(checklistInfo, 'general.isOneVotingPerUser', false);
		const isWithRegistration = _.get(checklistInfo, 'general.isWithRegistration', false);
		const isShowBackBtn = isBackBtnVisible && !isOneVotingPerUser && !isWithRegistration;
		return (
			<div
				className={classNames(
					css.socials,
					className,
					this.state.isOpen && css.open,
					inContentLocated && css.contentShares,
					isBackBtnVisible && css.backBtnEnabled,
					inItemLocated && css.itemShares
				)}
				ref={this.containerRef}
			>
				{!_.isEmpty(title) && (
					<h3 className={css.title} style={{ color: title?.titleColor }}>
						{title?.text}
					</h3>
				)}
				{!isHeaderSociallsVisible || !shareResults || !inItemLocated ? (
					<div className={css.overflowWrap}>
						<div
							className={css.btnsWrap}
							style={{ backgroundColor: isDesktop ? 'transparent' : headerBackground }}
						>
							<button
								type="button"
								className={css.mailBtn}
								id={SHARE_CONSTANTS.EMAIL}
								onClick={this.onShare}
							>
								<svg
									width="50px"
									height="50px"
									viewBox="0 0 50 50"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g id="share/mail" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
										<g id="share-3" fill={iconsColor}>
											<path
												d="M25.5,0 C39.0309764,-2.48560004e-15 50,10.9690236 50,24.5 L50,25.5 C50,39.0309764 39.0309764,50 25.5,50 L24.5,50 C10.9690236,50 1.65706669e-15,39.0309764 0,25.5 L0,24.5 C-1.65706669e-15,10.9690236 10.9690236,2.48560004e-15 24.5,0 L25.5,0 Z M37.1874352,13.5000536 L12.8124933,13.5000536 C11.2591904,13.5000536 10,14.7592441 10,16.3125469 L10,33.1875067 C10,34.7408096 11.2591904,36 12.8124933,36 L37.1874352,36 C38.7407381,36 39.9999285,34.7408096 39.9999285,33.1875067 L39.9999285,16.3125469 C39.9999285,14.7592441 38.7407381,13.5000536 37.1874352,13.5000536 Z M37.1874352,22.3124411 L37.1874352,33.1875067 L12.8124933,33.1875067 L12.8124933,22.3124411 C14.1551109,23.3818317 16.0591172,24.8824346 18.9612175,27.1549398 C20.2418655,28.1630474 22.4846733,30.3885174 24.9999642,30.3749562 C27.5028956,30.3885174 29.7172648,28.1953197 31.038196,27.1553975 C33.9402391,24.8829496 35.8447603,23.3819461 37.1874352,22.3124411 Z M37.1874352,16.3125469 L37.1874352,18.7034409 C35.8736566,19.7733465 33.7791639,21.4369129 29.301502,24.9430882 C28.3147375,25.7192819 26.3600341,27.584035 24.9999642,27.5622912 C23.6401233,27.5842638 21.6847904,25.7189958 20.6984265,24.9430882 C16.2214512,21.4374279 14.1264436,19.7735181 12.8124933,18.7034409 L12.8124933,16.3125469 L37.1874352,16.3125469 Z"
												id="Combined-Shape"
											></path>
										</g>
									</g>
								</svg>
							</button>
							<button
								type="button"
								className={css.whatsAppBtn}
								id={SHARE_CONSTANTS.WHATSAPP}
								onClick={this.onShare}
							>
								<svg
									width="50px"
									height="50px"
									viewBox="0 0 50 50"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g id="share/whatsapp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
										<g id="share-2" fill={iconsColor}>
											<path
												d="M25.5,0 C39.0309764,-2.48560004e-15 50,10.9690236 50,24.5 L50,25.5 C50,39.0309764 39.0309764,50 25.5,50 L24.5,50 C10.9690236,50 1.65706669e-15,39.0309764 0,25.5 L0,24.5 C-1.65706669e-15,10.9690236 10.9690236,2.48560004e-15 24.5,0 L25.5,0 Z M25.8691322,10.6250581 C18.6972514,10.6250581 12.8613507,16.4609588 12.8613507,23.6328396 C12.8613507,25.9238269 13.4589598,28.1621142 14.5956987,30.1367303 L12.75,36.8749955 L19.6464794,35.0644301 C21.544878,36.1015484 23.6835448,36.6464576 25.8632385,36.6464576 L25.8691322,36.6464576 C33.0351193,36.6464576 38.9999374,30.8105569 38.9999374,23.6386761 C38.9999374,20.1640864 37.523367,16.9004109 35.0683291,14.4394793 C32.6132339,11.9785476 29.3437219,10.6250581 25.8691322,10.6250581 Z M25.8749687,12.8223185 C28.7636223,12.8223185 31.476495,13.9473273 33.5155984,15.9922099 C35.5546446,18.0371498 36.8085135,20.7500225 36.8026973,23.6386761 C36.8026973,29.6035514 31.8280566,34.4550909 25.8691322,34.4550909 C23.9238129,34.4550909 22.0195206,33.9335848 20.3613329,32.9492236 L19.9687442,32.7148492 L15.8789217,33.7871008 L16.9687399,29.7968988 L16.7109052,29.3867436 C15.6269234,27.6640685 15.0586111,25.6777795 15.0586111,23.6328396 C15.0586111,17.673858 19.9101506,12.8223185 25.8749687,12.8223185 Z M21.2578037,17.632831 C21.0409959,17.632831 20.6894342,17.714885 20.3906297,18.0371498 C20.0917679,18.3652511 19.2538907,19.1504284 19.2538907,20.7500225 C19.2538907,22.3496166 20.4199265,23.8965108 20.5780834,24.1133187 C20.7421913,24.3301265 22.8691279,27.6113686 26.1328035,29.0234517 C28.1952528,29.9140861 29.0038904,29.9902463 30.035115,29.8379258 C30.6620781,29.7441417 31.956974,29.0527486 32.226539,28.2910316 C32.4960467,27.5293147 32.4960467,26.8789485 32.4139927,26.7441374 C32.3378325,26.5976534 32.1210247,26.5156567 31.7987598,26.3574425 C31.476495,26.1933918 29.8769008,25.4082145 29.5780963,25.3027575 C29.2792346,25.1914067 29.062484,25.1387068 28.8456762,25.4668082 C28.6288684,25.7949667 28.007799,26.5214931 27.8143943,26.7441374 C27.6269405,26.9609452 27.4335359,26.990242 27.111271,26.8261914 C25.2011422,25.871127 23.947216,25.1211402 22.6874534,22.9590131 C22.3535156,22.3848071 23.0214484,22.4258341 23.642575,21.1836381 C23.7480321,20.9668303 23.695275,20.7793193 23.6132782,20.6152687 C23.5698379,20.5284183 23.3671128,20.0392184 23.1459342,19.5015173 L22.9972935,19.1397475 C22.8490098,18.7785587 22.7064337,18.4307617 22.6112932,18.2012005 C22.3476219,17.5684009 22.0781142,17.6562914 21.878873,17.6445612 C21.691362,17.632831 21.4746115,17.632831 21.2578037,17.632831 Z"
												id="Combined-Shape"
											></path>
										</g>
									</g>
								</svg>
							</button>
							<button
								type="button"
								className={css.facebookBtn}
								id={SHARE_CONSTANTS.FACEBOOK}
								onClick={this.onShare}
							>
								<svg
									width="50px"
									height="50px"
									viewBox="0 0 50 50"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g id="share/facebook" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
										<g id="share-1" fill={iconsColor}>
											<path
												d="M25.5,0 C39.0309764,-2.48560004e-15 50,10.9690236 50,24.5 L50,25.5 C50,39.0309764 39.0309764,50 25.5,50 L24.5,50 C10.9690236,50 1.65706669e-15,39.0309764 0,25.5 L0,24.5 C-1.65706669e-15,10.9690236 10.9690236,2.48560004e-15 24.5,0 L25.5,0 Z M29.4546766,9.75006258 C25.1644113,9.75006258 22.3601577,12.3504401 22.3601577,17.0578416 L22.3601577,21.1957293 L17.5911871,21.1957293 L17.5911871,26.6250224 L22.3601577,26.6250224 L22.3601577,39.7499911 L28.2294751,39.7499911 L28.2294751,26.6250224 L32.6057998,26.6250224 L33.4390421,21.1957293 L28.2294751,21.1957293 L28.2294751,17.6725023 C28.2294751,16.1871772 28.9572031,14.7393314 31.290419,14.7393314 L33.6587682,14.7393314 L33.6587682,10.1168449 C33.6587682,10.1168449 31.5095156,9.75006258 29.4546766,9.75006258 Z"
												id="Combined-Shape"
											></path>
										</g>
									</g>
								</svg>
							</button>
						</div>
					</div>
				) : null}

				{inItemLocated && (
					<div className={css.inItemLocated} style={{ color: '#fff' }}>
						<button
							type="button"
							className={css.whatsAppBtn}
							id={SHARE_CONSTANTS.WHATSAPP}
							onClick={this.onShare}
						>
							<svg version="1.1" width="25px" height="25px" viewBox="0 0 25.0 25.0">
								<defs>
									<clipPath id="i0">
										<path d="M25,0 L25,25 L0,25 L0,0 L25,0 Z"></path>
									</clipPath>
									<clipPath id="i1">
										<path d="M11.7669373,0 C14.9076082,0.00115 17.8555134,1.19715 20.0723193,3.3672 C22.2891252,5.5384 23.5091912,8.42375 23.5068438,11.4931 C23.5033142,17.82385 18.2363432,22.97585 11.7657619,22.97585 C9.79579017,22.9747 7.86578208,22.49285 6.15087233,21.57745 L0,23 L1.59266807,17.22355 C0.565367779,15.48245 0.0246834166,13.50675 0.0258588174,11.48275 C0.0282096189,5.15085 5.29518055,0 11.7669373,0 Z M7.80640257,6.18150556 L7.61189551,6.18125 C7.41560358,6.18125 7.09824536,6.25255 6.82907858,6.54005 C6.5599118,6.8264 5.80177829,7.521 5.80177829,8.9332 C5.80177829,10.3454 6.8525866,11.7093 6.9995117,11.90135 C7.14526139,12.09225 9.02825346,15.0834 12.0102453,16.2334 C14.4879901,17.18905 14.9922371,16.9993 15.5305706,16.951 C16.0689042,16.90385 17.2666376,16.25755 17.5111209,15.5871 C17.7556043,14.91665 17.7556043,14.34165 17.6827295,14.2232 C17.6098546,14.1036 17.4147381,14.0323 17.1208879,13.88855 C16.8282131,13.7448 15.3859963,13.0502 15.1168295,12.95475 C14.8476628,12.8593 14.6513708,12.811 14.4562543,13.0985 C14.2611378,13.386 13.6992962,14.0323 13.5276877,14.2232 C13.3560792,14.41525 13.185646,14.4394 12.8917959,14.29565 C12.5979457,14.15075 11.6540988,13.8483 10.5327665,12.8708 C9.66061908,12.11065 9.07291869,11.1711 8.90131017,10.8836 C8.73087706,10.59725 8.88367916,10.44085 9.03060426,10.29825 C9.16224915,10.16945 9.32327906,9.9636 9.47020415,9.7957 C9.61595385,9.6278 9.66532069,9.5082 9.76287895,9.3173 C9.86043722,9.1264 9.81107038,8.9585 9.73819553,8.81475 C9.66532069,8.671 9.0952513,7.2519 8.83431233,6.6838 C8.61451238,6.20655 8.38295842,6.1962 8.17373708,6.18815 C8.00330397,6.18125 7.80701204,6.18125 7.61189551,6.18125 Z"></path>
									</clipPath>
								</defs>
								<g clipPath="url(#i0)">
									<g transform="translate(0.4931528554893081 1.0)">
										<g clipPath="url(#i1)">
											<polygon
												points="0,0 23.5068471,0 23.5068471,23 0,23 0,0"
												stroke="none"
												fill={iconsColor}
											></polygon>
										</g>
									</g>
								</g>
							</svg>
						</button>
						<button
							type="button"
							className={css.facebookBtn}
							id={SHARE_CONSTANTS.FACEBOOK}
							onClick={this.onShare}
						>
							<svg version="1.1" width="25px" height="25px" viewBox="0 0 25.0 25.0">
								<defs>
									<clipPath id="i2">
										<path d="M25,0 L25,25 L0,25 L0,0 L25,0 Z"></path>
									</clipPath>
									<clipPath id="i3">
										<path d="M11.7534253,0 C18.244842,0 23.5068505,5.17520229 23.5068505,11.5595316 C23.5068505,17.4109665 19.0816859,22.235915 13.344839,23 L13.344839,14.6228075 L16.3866255,14.6228075 L16.8638146,11.5838066 L13.3436637,11.5838066 L13.3436637,9.92270191 C13.3436637,8.66040107 13.763261,7.54028245 14.964461,7.54028245 L16.8943735,7.54028245 L16.8943735,4.88852591 C16.5546995,4.84344374 15.8389159,4.74518772 14.4837459,4.74518772 C11.6546965,4.74518772 9.99628818,6.21440418 9.99628818,9.56204453 L9.99628818,11.5838066 L7.08849077,11.5838066 L7.08849077,14.6228075 L9.99628818,14.6228075 L9.99628818,22.975725 C4.34053995,22.1399708 0,17.3543248 0,11.5595316 C0,5.17520229 5.26200849,0 11.7534253,0 Z"></path>
									</clipPath>
								</defs>
								<g clipPath="url(#i2)">
									<g transform="translate(0.9999999999996394 1.0)">
										<g clipPath="url(#i3)">
											<polygon
												points="0,0 23.5068505,0 23.5068505,23 0,23 0,0"
												stroke="none"
												fill={iconsColor}
											></polygon>
										</g>
									</g>
								</g>
							</svg>
						</button>
					</div>
				)}

				{!inContentLocated && !isHeaderSociallsVisible && !inItemLocated && (
					<div className={css.shareBtn} onClick={this.toggleOpenMenu}>
						<svg
							width="50px"
							height="50px"
							viewBox="0 0 50 50"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g id="share/mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="share-3" fill={iconsColor}>
									<path
										d="M25.5,0 C39.0309764,-2.48560004e-15 50,10.9690236 50,24.5 L50,25.5 C50,39.0309764 39.0309764,50 25.5,50 L24.5,50 C10.9690236,50 1.65706669e-15,39.0309764 0,25.5 L0,24.5 C-1.65706669e-15,10.9690236 10.9690236,2.48560004e-15 24.5,0 L25.5,0 Z M30.4999607,13.2000501 C28.0147218,13.2000501 25.9999714,15.2148005 25.9999714,17.7000393 C25.9999714,18.0355793 26.0370044,18.362376 26.1066758,18.6769505 L21.3026407,21.679461 C20.5337369,21.0665627 19.5597554,20.7000322 18.4999893,20.7000322 C16.0147504,20.7000322 14,22.7147826 14,25.2000215 C14,27.6852603 16.0147504,29.7000107 18.4999893,29.7000107 C19.5597554,29.7000107 20.5337369,29.3334802 21.3026407,28.7205819 L26.1066758,31.7230925 C26.0543536,31.9594009 26.0205707,32.2026617 26.0069494,32.4512525 L26,32.701 L25.9999714,32.7000036 C25.9999714,35.1852424 28.0147218,37.1999928 30.4999607,37.1999928 C32.9851995,37.1999928 34.9999499,35.1852424 34.9999499,32.7000036 C34.9999499,30.2147648 32.9851995,28.2000143 30.4999607,28.2000143 C29.4401945,28.2000143 28.4662131,28.5665448 27.6973093,29.1794431 L22.8932741,26.1769326 C22.9630371,25.8613968 22.9998412,25.5335015 22.9998412,25.1970918 C22.9998412,24.8606821 22.9630371,24.5386003 22.8932741,24.2230646 L27.6973093,21.2205082 C28.4662131,21.8334981 29.4401945,22.2000286 30.4999607,22.2000286 C32.9851995,22.2000286 34.9999499,20.1852782 34.9999499,17.7000393 C34.9999499,15.2148005 32.9851995,13.2000501 30.4999607,13.2000501 Z"
										id="Combined-Shape"
									></path>
								</g>
							</g>
						</svg>
					</div>
				)}
				{isShowBackBtn && (
					<button
						type="button"
						className={css.backBtn}
						id="back"
						onClick={this.onBack}
						style={{ color: `${iconsColor}` }}
					>
						<span>{backBtnLabel}</span>
						<span className={css.backBtnIcon} style={{ backgroundColor: `${iconsColor}` }} />
					</button>
				)}
			</div>
		);
	}
}

const mapState = (state: ClientStore) => ({
	shareResult: state.shareResult,
	checklistInfo: state.checklist.item,
});

export default withRouter(connect(mapState, {})(Socials));
